// @ts-strict-ignore
import { useState } from 'react';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import {
    Checkbox,
    TextField,
    Button,
    Autocomplete,
    createFilterOptions,
} from '@mui/material';

type MetaValue = string;
type MetaSelectOption = {
    value: MetaValue;
    label: string;
};
// todo. <ProjectsFilter /> passes data sheets here, but this component uses another format.
//       Either way, it is not currently in use. I believe the purpose would be to show the
//       number of surveys for each option. But to do this, it is better to do some kind of
//       meta groups like we do for respondent count, this way there is no need for round-trips
//       to the backend.
// type MetaResult = any;

interface ProjectMetaSelectProps<
    T extends MetaSelectOption = MetaSelectOption,
> {
    options: ReadonlyArray<T>;
    label: ReactNode;
    color?: string;
    metaKey: string;
    metaValues: ReadonlyArray<MetaValue>;
    //metaResults: ReadonlyArray<MetaResult>;
    // loadingMetaResults: boolean;

    onChange(metaKey: string, metaValues: ReadonlyArray<MetaValue>): void;

    questionnaireId: string;
}

const filter = createFilterOptions<{ label: string; value: string }>();

export function ProjectMetaSelect<
    T extends MetaSelectOption = MetaSelectOption,
>(props: ProjectMetaSelectProps<T>) {
    const { options, label } = props;
    const [open, setOpen] = useState(false);
    // const [shouldMountResultsLoader, setShouldMountResultsLoader] =
    //     useState(false);
    const [selectedOptions, setSelectedOptions] = useState<ReadonlyArray<T>>(
        options.filter((option) => props.metaValues.includes(option.value)),
    );
    // const [metaResults, setMetaResults] = useState(props.metaResults);
    // const [loadingMetaResults, setLoadingMetaResults] = useState(false);

    return (
        <Autocomplete
            forcePopupIcon
            clearOnBlur
            clearOnEscape
            multiple
            disableCloseOnSelect
            autoHighlight
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            onBlur={() => {
                props.onChange(
                    props.metaKey,
                    selectedOptions.map(({ value }) => value),
                );
            }}
            // ref={ref}
            renderInput={(props) => (
                <TextField
                    {...props}
                    inputProps={{
                        ...props.inputProps,

                        // We have added this in the theme for MuiTextField, not sure why it's not added
                        // automatically here
                        autoComplete: 'off',
                        // Prevent lastpass
                        'data-lpignore': 'true',
                    }}
                    margin="normal"
                    label={label}
                />
            )}
            value={selectedOptions.slice()}
            options={options}
            onChange={(_event, values, reason) => {
                if (values.some((value) => value.value === '')) {
                    setOpen(false);
                } else {
                    setSelectedOptions(
                        values.filter(({ value }) => value !== ''),
                    );
                    if (reason !== 'selectOption') {
                        props.onChange(
                            props.metaKey,
                            values.map(({ value }) => value),
                        );
                    }
                }
            }}
            ChipProps={{
                color: 'primary',
            }}
            getOptionKey={(option) => option.value}
            renderOption={({ key, ...props }, option, state, ownerState) => {
                return (
                    <li {...props} key={option.value}>
                        {option.value === '' ? (
                            <Button
                                onClick={(event) =>
                                    ownerState.onClose?.(event, 'escape')
                                }
                                fullWidth
                            >
                                <FormattedMessage
                                    defaultMessage="Close"
                                    description="Close button"
                                />
                            </Button>
                        ) : (
                            <>
                                <Checkbox checked={state.selected} />
                                {option.label}
                            </>
                        )}
                    </li>
                );
            }}
            isOptionEqualToValue={(a, b) =>
                a.value === b.value || b.value === ''
            }
            // onBlur={onBlur}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                filtered.push({
                    label: '',
                    value: '',
                });
                return filtered as T[];
            }}
        />
    );
}

export default ProjectMetaSelect;
